/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useRef, useState } from 'react'
import '../../Styles/OnboardingContainer.css'
import StepperCompenent from '../../Common/ui/stepper'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material'
import { Card, CardContent } from '../../Common/ui/card'
import { Button } from '../../Common/ui/button'
import DynamicInput from '../../Components/DynamicInput'
import { Tabs, TabsList, TabsTrigger } from '../../Common/ui/tabs'
import * as InputEntities from '../../Entities/InputTypes'
import { useForm } from 'react-hook-form'
import AddSquareIcon from '../../Common/Icon/AddSquareIcon'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import RegulationList from '../../Components/Onboarding/RegulationList'
import OrganizationChart from '../../Components/OrganizationChart/OrganizationChart'
import BoardComposition from '../../Components/Onboarding/BoardComposition'
import { useNodesState, useEdgesState, ReactFlowProvider } from 'reactflow'
import { useOnboardingStore, useOnboardingStoreForSurvey, useProfileScreenStore } from './Store/OnboardingStore'
import Loading from '../../Common/ui/Loading'
import useCustomNavigate from '../../Common/ui/Navigate'
import { cn } from '../../lib/utils'
import { RxTrash } from 'react-icons/rx'
import { useGovernanceStore } from './Store/GovernanceStore'
import { IoArrowForward, IoArrowBack } from 'react-icons/io5'
import { IoMdCheckmark } from 'react-icons/io'
import { useCommonStore } from 'src/Common/store/CommonStore'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router'
import { useLoginStore } from 'src/Containers/Auth/Store/Store'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import * as RoutePaths from '../../Entities/RoutePath'
import * as MainContainerEntity from '../../Entities/MainContainerTypes'
import { getExistingEmailandPhoneno } from 'src/API/CommonAPI'
import ProfileScreen from '../../Components/Onboarding/ProfileScreen'
import { editOrganizationChartNode } from 'src/API/OnboardingAPI'
import { useSettingsStore } from '../SettingsContainer/Store/Store'
import { ConfigurationsContainer } from '../SettingsContainer/Configurations/ConfigurationsContainer'

const OnboardingContainer = () => {
    const orgId = localStorage.getItem('orgId')
    const vertexId = localStorage.getItem('vertexId')
    const loginId = localStorage.getItem('userId')

    const curencyCode = [{ id: 4, currencyName: 'Oman Riyal', name: 'OMR', status: 1 }, { id: 1, currencyName: 'United States dollar', name: 'USD', status: 1 }, { id: 2, currencyName: 'Indian rupee', name: 'INR', status: 1 }, { id: 3, currencyName: 'Euro', name: 'EURO', status: 1 }]
    const heatMap = [{ id: 1, name: '3x3', status: 1 }, { id: 2, name: '5x5', status: 1 }]

    const customNavigate = useCustomNavigate()
    const { handleSubmit, reset, formState: { errors, isLoading, isSubmitting }, control, trigger, setError, clearErrors, register, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {}
    })
    const createSurveyTemplate = useOnboardingStore(state => state.createSurveyTemplate)
    const updateSurveyTemplate = useOnboardingStore(state => state.updateSurveyTemplate)
    const getSurveyTemplate = useOnboardingStoreForSurvey(state => state.getSurveyTemplate)
    const createBoardComposition = useOnboardingStore((state) => state.createBoardComposition)
    const getBoardComposition = useOnboardingStore((state) => state.getBoardComposition)
    const createOrganizationChart = useOnboardingStore((state) => state.createOrganizationChart)
    const createCompanyProfileLoading = useProfileScreenStore((state) => state.createCompanyProfileLoading)
    const getCompanyProfileLoading = useProfileScreenStore((state) => state.getCompanyProfileLoading)
    const getOrganizationChart = useOnboardingStore((state) => state.getOrganizationChart)
    const getOrgRegulation = useOnboardingStore((state) => state.getOrgRegulation)
    const { getCompanyProfile, getCompanyProfileData, createCompanyProfile } = useProfileScreenStore()
    const { getSurveyTemplateData, getSurveyTemplateLoading, orgTypeData, getOrgType } = useOnboardingStoreForSurvey()
    // const { getSurveyTemplateLoading } = useOnboardingStoreForSurvey()
    const { sendInnviteFronOnboarding, sendInnviteFronOnboardingLoading } = useLoginStore()
    const [ isOpenOnboardProfileModal, setIsOpenOnboardProfileModal ] = useState(false)
    const { rollDataLoading, rollData, departmentByOrgId, designationByOrgId } = useCommonStore()
    const { createBoardCompositionLoading, createOrganizationChartLoading, createOrgRegulationLoading, updateSurveyTemplateLoading, getOrgRegulationLoading, getOrganizationChartLoading, getBoardCompositionLoading, createSurveyTemplateLoading } = useOnboardingStore()
    const [ nodes, setNodes, onNodesChange ] = useNodesState([])
    const [ edges, setEdges, onEdgesChange ] = useEdgesState([])
    const cardContainerRef = useRef(null)
    const [ profileFormData, setProfileFormData ] = useState(MainContainerEntity.getSurveyTemplateDataNew)

    const [ groupedData, setGroupedData ] = useState([])
    const [ activeTab, setActiveTab ] = useState()
    const [stepperdData] = useState([
        { label: 'Profile', id: 1 },
        { label: 'Board Member', id: 2 },
        { label: 'Organization Chart', id: 3 },
        { label: 'Applicable Regulations', id: 4 },
        { label: 'Mandate Setup', id: 5 }
    ])
    const [ activeStepper, setActiveStepper ] = useState(localStorage.getItem('activeStepper') ? Number(localStorage.getItem('activeStepper')) : 0)
    const [ tabWidth, setTabWidth ] = useState(cardContainerRef?.current?.clientWidth)
    const [ regulationTableData, setRegulationTableData ] = useState([])
    const [ showSubmitButton, setShowSubmitButton ] = useState(false)
    const [ regulationListData, setRegulationListData ] = useState([
        { id: 1, value: 'Ministry of Corporate Affairs (MCA)', isChecked: false },
        { id: 2, value: 'Securities and Exchange Board of India (SEBI)', isChecked: false },
        { id: 3, value: 'Reserve Bank of India (RBI)', isChecked: false },
        { id: 4, value: 'Insurance Regulatory and Development Authority of India (IRDAI)', isChecked: false },
        { id: 5, value: 'Ministry of Labour and Employment', isChecked: false }])
    const { governanceLoading } = useGovernanceStore()
    const { getAllFeaturesF } = useCommonStore()
    const [ boardsFormData, setBoardsFormData ] = useState([
        {
            firstName: null,
            middleName: null,
            lastName: null,
            emailId: null,
            phoneNo: null,
            phoneCode: null,
            phoneCountryCode: null,
            isActive: false,
            address: null,
            city: null,
            state: null,
            country: null,
            pincode: null
        }
    ])
    const [ roleData, setRoleData ] = useState([])
    const [ profileData, setProfileData ] = useState({
        id: null,
        name: '',
        organizationTypeId: null,
        industry: '',
        inagurationDate: '',
        currencyCode: '',
        currencyName: '',
        heatmap: {
            id: null,
            name: ''
        },
        status: 1,
        financialYearId: null,
        financialYear: {
            id: null,
            fromDate: '2024-10-29T21:21:38.271268Z',
            toDate: '2024-10-30T21:21:38.271268Z',
            status: 1
        },
        orgLogo: {},
        orgAddress: [
            {
                tabName: 'Head/Corporate Office',
                orgId,
                street: '',
                countryId: '',
                stateId: '',
                cityId: '',
                pincode: '',
                addressTypeId: 1,
                isRegisteredAddress: true,
                status: 1,
                addressId: 0
            },
            {
                tabName: 'Branch Office(s)',
                orgId,
                street: '',
                countryId: '',
                stateId: '',
                cityId: '',
                pincode: '',
                addressTypeId: 2,
                isRegisteredAddress: false,
                status: 1,
                addressId: 0
            }
        ]
    })

    const templateId = 1
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const { t } = useTranslation()
    const [ depByOrgId, setDepByOrgId ] = useState([])
    const [ desByOrgId, setDesByOrgId ] = useState([])
    const userId = localStorage.getItem('userId')
    const { getFeatureNavigationMenu } = useGovernanceStore()

    useEffect(() => {
        if (departmentByOrgId.length > 0) {
            setDepByOrgId(departmentByOrgId)
        }
        if (designationByOrgId.length > 0) {
            setDesByOrgId(designationByOrgId)
        }
        if (rollData.length > 0) {
            setRoleData(rollData)
        }
    }, [ rollData, departmentByOrgId, designationByOrgId ])

    useEffect(() => {
        const handleResize = () => {
            if (cardContainerRef?.current) {
                setTabWidth(cardContainerRef?.current?.clientWidth)
            }
        }

        setTimeout(() => {
            if (cardContainerRef?.current) {
                setTabWidth(cardContainerRef?.current?.clientWidth)
            }
        }, 100)
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [cardContainerRef?.current])

    // useEffect(() => {
    //     if (profileFormData.length > 0) {
    //         const groupNameArray = profileFormData[0]?.questions?.map(item => item?.questionGroupName)
    //         const sortedGroupName = Array.from(new Set(groupNameArray))
    //         const groupObj = {}
    //         for (let i = 0; i < sortedGroupName?.length; i++) {
    //             const sortedForm = profileFormData.find(grp => grp?.questionGroupId === profileFormData[0].questionGroupId)
    //             groupObj[sortedGroupName[i]] = sortedForm?.questions.filter(group => group.questionGroupName === sortedGroupName[i])
    //         }
    //         setGroupedData(groupObj)
    //     }
    // }, [profileFormData])

    // useEffect(() => {
    //     if (getSurveyTemplateData.length > 0) {
    // setProfileFormData(getSurveyTemplateData)
    // const groupNameArray = getSurveyTemplateData[0]?.questions?.map(item => item?.questionGroupName)
    // const sortedGroupName = Array.from(new Set(groupNameArray))
    // const groupObj = {}
    // for (let i = 0; i < sortedGroupName?.length; i++) {
    //     const sortedForm = getSurveyTemplateData.find(grp => grp?.questionGroupId === getSurveyTemplateData[0].questionGroupId)
    //     groupObj[sortedGroupName[i]] = sortedForm?.questions.filter(group => group.questionGroupName === sortedGroupName[i])
    // }
    //     }
    // }, [getSurveyTemplateData])

    // const extractInitialValues = (surveyData) => {
    //     const initialValues = {}
    //     surveyData.forEach((ele) => {
    //         ele.questions.map((item, i) => {
    //             initialValues[`${item.qName}-${item.qId}-${i}`] = item.answerNumeric || item.answerText
    //             if (item.qName.includes(OnboardEntity.HEAD) || item.qName.includes(OnboardEntity.BRANCH)) {
    //                 item.addressDetails.map(el => {
    //                     Object.keys(el).map((obj) => {
    //                         el[obj].map((el2, j) => {
    //                             initialValues[`${el2.qName}-${el2.qId}-${j}-${obj}`] = el2.answerNumeric || el2.answerText
    //                         })
    //                     })
    //                 })
    //             }
    //             return item
    //         })
    //     })
    //     return initialValues
    // }
    // useEffect(() => {
    //     if (MainContainerEntity.getSurveyTemplateDataNew.length > 0) {
    //         const initialValues = extractInitialValues(MainContainerEntity.getSurveyTemplateDataNew)
    //         reset(initialValues)
    //     }
    //     getOrgType(orgId)
    // }, [ MainContainerEntity.getSurveyTemplateDataNew, reset ])
    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (activeStepper === OnboardEntity.PROFILE_STEPPER) {
                    // await getSurveyTemplate(vertexId || 0, templateId)
                } else if (activeStepper === OnboardEntity.MANAGEMENT_TEAM_STEPPER) {
                    await getBoardComposition(orgId)
                } else if (activeStepper === OnboardEntity.ORGANIZATION_CHART_STEPPER) {
                    await getOrganizationChart(orgId, loginId)
                } else if (activeStepper === OnboardEntity.BODIES_LIST_STEPPER && bodyType) {
                    await getOrgRegulation(orgId, loginId, bodyType)
                } else if (activeStepper === OnboardEntity.BODIES_LIST_STEPPER && !bodyType) {
                    customNavigate(RoutePaths.ONBOARDING.URI + '?bodyType=1', RoutePaths.ONBOARDING.NAME)
                    await getOrgRegulation(orgId, loginId, bodyType)
                } else if (activeStepper === OnboardEntity.CONFIGURATION_STEPPER) {
                    await getConfigurationBasedOrganization(orgId)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }

        fetchData()
    }, [ activeStepper, bodyType ])

    // const onTabValueChange = value => {
    //     reset()
    //     setActiveTab(value)
    //     if (profileFormData.length > 0) {
    //         const initialValues = extractInitialValues(profileFormData)
    //         reset(initialValues)
    //     }
    // }
    // const handleClickAddNew = (key, item, qId, inputTypeId, indexx) => {
    //     reset()

    //     setProfileFormData(profileFormData.map((formEl, index) => {
    //         if (activeStepper === index) {
    //             const findLastIndexOfBranchOffice = formEl?.questions?.find((findDt) => findDt?.qId === 12)?.addressDetails
    //             const lastindexAddress = Object.values(findLastIndexOfBranchOffice[findLastIndexOfBranchOffice?.length - 1])[0]
    //             let qIdCounter = lastindexAddress[lastindexAddress?.length - 1]?.qId + 1

    //             const formQn = formEl?.questions?.map((qnEl, indexQl) => {
    //                 if (qnEl?.qId === qId) {
    //                     const addressDetailsAdd = qnEl[handleNestedKeyName(qnEl?.questionGroupName)]

    //                     addressDetailsAdd.push({
    //                         [Object.keys(qnEl[handleNestedKeyName(qnEl?.questionGroupName)][0])[0] + (qnEl[handleNestedKeyName(qnEl?.questionGroupName)]?.length + 1)]: item[key]?.map(addEl => {
    //                             return { ...addEl, answer: null, answerKeys: null, answerText: null, answerNumeric: null, qId: ++qIdCounter }
    //                         })
    //                     })
    //                     return { ...qnEl, [handleNestedKeyName(qnEl?.questionGroupName)]: addressDetailsAdd }
    //                 } else {
    //                     return qnEl
    //                 }
    //             })
    //             return { ...formEl, questions: formQn }
    //         } else {
    //             return formEl
    //         }
    //     }))
    // }

    // const handleDefaultTab = (tabArr, inputTypeId) => {
    //     if (tabArr?.filter(flt => flt.inputTypeId === InputEntities.TAB_ID || flt.inputTypeId === InputEntities.ACCORDIAN_ID)) {
    //         if (activeTab && inputTypeId === InputEntities.TAB_ID) {
    //             return activeTab
    //         } else if (!activeTab && inputTypeId === InputEntities.TAB_ID) {
    //             return Object.keys(tabArr?.filter(flt => flt.inputTypeId === InputEntities.TAB_ID)[0]?.addressDetails[0])[0]
    //         }
    //     } else {
    //         return ''
    //     }
    // }

    // const handleDeleteTab = (key, item, qId, inputTypeId, indexx) => {
    //     const deletedData = profileFormData.map((formEl, index) => {
    //         if (activeStepper === index) {
    //             const formQn = formEl?.questions?.map((qnEl, indexQl) => {
    //                 if (qnEl?.qId === qId) {
    //                     const deletedObject = qnEl[handleNestedKeyName(qnEl?.questionGroupName)]
    //                     deletedObject.pop()
    //                     return { ...qnEl, [handleNestedKeyName(qnEl?.questionGroupName)]: deletedObject }
    //                 } else {
    //                     return qnEl
    //                 }
    //             })

    //             return { ...formEl, questions: formQn }
    //         } else {
    //             return formEl
    //         }
    //     })
    //     setProfileFormData(deletedData)
    // }

    const organizationProfile = groupedData[OnboardEntity.ORGANIZATION_PROFILE]
    const Address = groupedData.Address?.map((mapDt) => mapDt?.addressDetails).flatMap(group => {
        return group.flatMap(branch => {
            return Object.values(branch)[0]
        })
    })

    const fillMissingQuestionIds = (data, startId, endId) => {
        const ids = data?.map(item => item.qId)
        const filledData = [...data]

        for (let i = startId; i <= endId; i++) {
            if (!ids.includes(i)) {
                const newObj = {
                    qId: i,
                    inputTypeId: 6,
                    answerNumeric: 0,
                    answerText: OnboardEntity.BRANCH_OFFICE_S,
                    answerKeys: [0]
                }
                filledData.push(newObj)
            }
        }
        filledData.sort((a, b) => a.qId - b.qId)
        return filledData
    }
    const orgProfileandAddressResponse = fillMissingQuestionIds(organizationProfile?.concat(Address) || [], 16, organizationProfile?.concat(Address)[organizationProfile?.concat(Address)?.length - 1]?.qId)

    const surveyRequests = {
        templateId: 1,
        vertexId: 0,
        answers: orgProfileandAddressResponse?.map((mapDt) => {
            return {
                questionId: Number(mapDt?.qId),
                inputTypeId: Number(mapDt?.inputTypeId),
                answerNumeric: Number(mapDt?.answerNumeric) || 0,
                answerText: (mapDt?.qName === InputEntities.COUNTRY || mapDt?.qName === InputEntities.STATE || mapDt?.qName === InputEntities.CITY) ? mapDt?.answerText : mapDt?.answer?.value || mapDt?.answerText,
                answerKeys: mapDt?.answerKeys || []
            }
        })
    }
    const updateSurveyRequests = {
        templateId: 1,
        vertexId,
        answers: orgProfileandAddressResponse?.map((mapDt) => {
            return {
                questionId: Number(mapDt?.qId),
                inputTypeId: Number(mapDt?.inputTypeId),
                answerNumeric: Number(mapDt?.answerNumeric) || 0,
                answerText: (mapDt?.qName === InputEntities.COUNTRY || mapDt?.qName === InputEntities.STATE || mapDt?.qName === InputEntities.CITY) ? mapDt?.answerText : mapDt?.answer?.value || mapDt?.answerText,
                answerKeys: mapDt?.answerKeys || []
            }
        })
    }
    const userRequests = boardsFormData?.map((data) => ({
        firstName: data?.firstName || '',
        middleName: data?.middleName || '',
        lastName: data?.lastName || '',
        emailId: data?.emailId || '',
        phoneNo: data?.phoneNumber || '',
        phoneCode: data?.phoneCode || '',
        phoneCountryCode: data?.phoneCountryCode || '',
        isActive: data?.isActive || false,
        userId: data?.userId || 0,
        orgId,
        address: data?.address || '',
        city: data?.address ? data?.city : '',
        state: data?.address ? data?.state : '',
        country: data?.address ? data?.country : '',
        pincode: data?.address ? data?.pincode : '',
        status: data?.status || 1
    }))

    const boardCompositionFormData = new FormData()

    const appendFormData = (formData, data, parentKey = '') => {
        if (data && typeof data === 'object' && !Array.isArray(data)) {
            Object.keys(data).forEach(key => {
                const newKey = parentKey ? `${parentKey}[${key}]` : key
                appendFormData(formData, data[key], newKey)
            })
        } else if (Array.isArray(data)) {
            data.forEach((item, index) => {
                const newKey = `${parentKey}[${index}]`
                appendFormData(formData, item, newKey)
            })
        } else {
            formData.append(parentKey, data)
        }
    }

    userRequests.forEach((obj, index) => {
        Object.keys(obj).forEach(key => {
            const newKey = `createUser[${index}][${key}]`
            appendFormData(boardCompositionFormData, obj[key], newKey)
        })
    })

    const chartRequest = nodes?.filter((filterdt, filteridx) => filteridx !== 0)?.map((dt) => {
        const foundDesignation = desByOrgId.find(des => des?.name?.toLowerCase() === dt?.data?.designation?.toLowerCase())
        const designationId = foundDesignation ? foundDesignation.id : ''

        const foundDepartment = depByOrgId.find(dep => dep?.name?.toLowerCase() === dt?.data?.department?.toLowerCase())
        const departmentId = foundDepartment ? foundDepartment.id : ''

        return {
            empId: dt?.data?.id,
            firstName: dt?.data?.firstName || '',
            middleName: dt?.data?.middleName || '',
            lastName: dt?.data?.lastName || '',
            displayName: dt?.data?.displayName || '',
            designation: '',
            designationId,
            level: dt?.data?.level || '',
            departmentId,
            department: '',
            emailId: dt?.data?.emailId || '',
            phoneNo: dt?.data?.phoneNumber || '',
            phoneCode: dt?.data?.phoneCode || '',
            phoneCountryCode: dt?.data?.phoneCountryCode || '',
            role: dt?.data?.role?.map((roleName, index) => {
                const role = roleData?.find(item => item.name === roleName)
                return role ? role?.id : null
            })?.filter(roleId => roleId !== null),
            fromDate: dt?.data?.fromDate || new Date().toISOString(),
            toDate: dt?.data?.toDate || new Date().toISOString(),
            atPresent: dt?.data?.atPresent || true,
            profilePic: dt?.data?.profilePic || '',
            reportsTo: dt?.data?.reportsTo || 0,
            x: dt?.position?.x,
            y: dt?.position?.y,
            status: dt?.data?.status
        }
    })

    const chartRequestFormData = new FormData()

    const appendFormDataOrgChart = (formData, data, parentKey = '') => {
        if (data && typeof data === 'object' && !Array.isArray(data)) {
            Object.keys(data).forEach(key => {
                const newKey = parentKey ? `${parentKey}[${key}]` : key
                appendFormDataOrgChart(formData, data[key], newKey)
            })
        } else if (Array.isArray(data)) {
            data.forEach((item, index) => {
                const newKey = `${parentKey}[${index}]`
                appendFormDataOrgChart(formData, item, newKey)
            })
        } else {
            formData.append(parentKey, data)
        }
    }

    chartRequest.forEach((obj, index) => {
        Object.keys(obj).forEach(key => {
            const newKey = `chartRequests[${index}][${key}]`
            appendFormDataOrgChart(chartRequestFormData, obj[key], newKey)
        })
    })

    const resetErrorsForBoardFields = (boardMemberData) => {
        const initialValues = {}

        boardMemberData.map((mapDt, idx) => {
            Object.entries(mapDt).forEach(([ key, value ]) => {
                if (key === OnboardEntity.FIRST_NAME) {
                    initialValues[`dropText${idx}`] = value
                } else if (key === 'emailId') {
                    initialValues[`emailId-${idx}`] = value
                } else {
                    initialValues[`${key}${idx}`] = value
                }
            })
        })
        return initialValues
    }

    useEffect(() => {
        const boardErrors = resetErrorsForBoardFields(boardsFormData)
        reset(boardErrors)
    }, [ boardsFormData, reset ])
    const ref = useRef()

    const handleNext = (data) => {
        if (activeStepper === OnboardEntity.PROFILE_STEPPER) {
            const hasRegisteredAddress = profileData.orgAddress.some(address => address.isRegisteredAddress)
            getAllFeaturesF(userId)
            if (!hasRegisteredAddress) {
                setRegAddValidation(false)
                toast.warning(<p className='w-[100%] flex flex-row justify-evenly items-center'><p>{t('Select atleast one registered Address')}</p></p>, {
                    position: 'top-right', autoClose: 5000, closeButton: false, theme: 'light'
                })
            } else {
                const createCompProfileRequest = {
                    id: profileData?.id || 0,
                    name: profileData?.name,
                    organizationTypeId: profileData?.organizationTypeId,
                    industry: profileData?.industry,
                    [OnboardEntity.ORG_LOGO_KEY]: profileData?.[OnboardEntity.ORG_LOGO_KEY],
                    inagurationDate: typeof profileData?.inagurationDate === 'object' ? profileData?.inagurationDate?.toISOString() : profileData?.inagurationDate,
                    currencyCode: curencyCode?.find((findDt, _) => findDt?.id === profileData?.currencyCode)?.name,
                    currencyName: curencyCode?.find((findDt, _) => findDt?.id === profileData?.currencyCode)?.currencyName,
                    status: 1,
                    financialYearId: 1,
                    orgAddress: profileData?.orgAddress?.filter?.((filterDt, _) => filterDt?.street?.length > 0)?.map((mapDt, mapIdx) => {
                        return {
                            street: mapDt?.street,
                            countryId: mapDt?.countryId,
                            stateId: mapDt?.stateId,
                            cityId: mapDt?.cityId,
                            addressTypeId: mapDt?.addressTypeId,
                            pincode: mapDt?.pincode,
                            isRegisteredAddress: mapDt?.isRegisteredAddress,
                            status: mapDt?.status,
                            addressId: mapDt?.addressId
                        }
                    })
                }
                if (data) {
                    try {
                        createCompanyProfile(createCompProfileRequest, loginId)
                            .then((response) => {
                                if (response?.data) {
                                    setActiveStepper(activeStepper + 1)
                                    localStorage.setItem('activeStepper', activeStepper + 1)
                                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Organization details updated successfully')}</p></p>, {
                                        position: 'top-right', theme: 'light'
                                    })
                                    localStorage.setItem('orgId', response?.data)
                                }
                            })
                    } catch (err) {
                        console.error('Error posting organization data:', err)
                        toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in creating organization try again!')}</p></p>, {
                            position: 'top-right', hideProgressBar: true, theme: 'light'
                        })
                    }
                }
            }
        } else if (activeStepper === OnboardEntity.MANAGEMENT_TEAM_STEPPER) {
            createBoardComposition(boardCompositionFormData, loginId)
                .then((response) => {
                    if (response?.data) {
                        setActiveStepper(activeStepper + 1)
                        localStorage.setItem('activeStepper', activeStepper + 1)
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Board Member added successfully')}</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                    } else {
                        const warningMessage = response?.err?.response?.data?.errors
                        if (warningMessage.length > 0) {
                            warningMessage.forEach((message) => {
                                toast.warning(<p>{message}</p>, { position: 'top-right', theme: 'light' })
                            })
                        } else {
                            toast.warning(<p>{warningMessage}</p>, { position: 'top-right', theme: 'light' })
                        }
                    }
                })
                .catch((err) => {
                    console.error('Error posting board composition data:', err)
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in adding management team try again!')}</p></p>, {
                        position: 'top-right', hideProgressBar: true, theme: 'light'
                    })
                })
        } else if (activeStepper === OnboardEntity.ORGANIZATION_CHART_STEPPER) {
            editOrganizationChartNode(chartRequest)
                .then((response) => {
                    setActiveStepper(activeStepper + 1)
                    localStorage.setItem('activeStepper', activeStepper + 1)
                    toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Employee details added successfully')}</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    const userId = localStorage.getItem('userId')
                })
                .catch((err) => {
                    console.error('Error posting organization chart data:', err)
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>{t('Error in creating employee details try again!')}</p></p>, {
                        position: 'top-right', hideProgressBar: true, theme: 'light'
                    })
                })
        } else if (activeStepper === OnboardEntity.BODIES_LIST_STEPPER) {
            setActiveStepper(activeStepper + 1)
        } else if (activeStepper === OnboardEntity.CONFIGURATION_STEPPER) {
            ref.current.handleSav()
            setIsOpenOnboardProfileModal(true)
            sendInnviteFronOnboarding(orgId, null)
                .then((res) => {
                    if (res.data) {
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Invite has been sent successfully.')}</p></p>, {
                            position: 'top-right',
                            theme: 'light'
                        })
                        getConfigurationBasedOrganization(orgId)
                    } else {
                        toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Failed to send OTP. Please try again later.')}</p></p>, {
                            position: 'top-right',

                            theme: 'light'
                        })
                    }

                    getAllFeaturesF(userId)
                    getFeatureNavigationMenu(userId, orgId)
                })
                .catch((err) => {
                    console.warn(err)
                    toast.error(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{t('Failed to send OTP. Please try again later.')}</p></p>, {
                        position: 'top-right',

                        theme: 'light'
                    })
                })
        }
    }

    const handleCloseModal = () => {
        setIsOpenOnboardProfileModal(false)
    }

    const handleContinue = () => {
        customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.GOVERNANCE.ORG_CHART, MainContainerEntity.MENU_TYPE_GOV_ORG_CHART)
        setShowSubmitButton(true)
    }

    const handleBack = () => {
        if (activeStepper !== OnboardEntity.PROFILE_STEPPER) {
            setActiveStepper(activeStepper - OnboardEntity.MANAGEMENT_TEAM_STEPPER)
            localStorage.setItem('activeStepper', activeStepper - OnboardEntity.MANAGEMENT_TEAM_STEPPER)
        }
        if (activeStepper === OnboardEntity.MANAGEMENT_TEAM_STEPPER) {
            setActiveTab(OnboardEntity.HEAD_OFFICE)
        }
    }

    // const handleNestedKeyName = questionGroupName => {
    //     if (questionGroupName === OnboardEntity.ADDRESS_GROUP_NAME) {
    //         return OnboardEntity.ADDRESS_DETAILS_KEY
    //     } else if (questionGroupName === OnboardEntity.BOARD_COMPOSITION_GROUP_NAME) {
    //         return OnboardEntity.BOARD_DETAILS_KEY
    //     }
    // }

    const [ regAddValidation, setRegAddValidation ] = useState(false)

    return (
        <>
            <div className='onboarding-container'>
                <Loading isLoading={getCompanyProfileLoading || getSurveyTemplateLoading || governanceLoading || updateSurveyTemplateLoading || createSurveyTemplateLoading || createBoardCompositionLoading || createOrganizationChartLoading || createOrgRegulationLoading || getOrgRegulationLoading || getOrganizationChartLoading || getBoardCompositionLoading || rollDataLoading || sendInnviteFronOnboardingLoading || createCompanyProfileLoading} />
                {/* <div className='w-[100%] h-[9%] flex flex-col items-center justify-center pt-6'>
                    <img loading="lazy" className='w-9' src={'/Assets/GrcNavLogo.svg'} alt='nav-logo' />
                    <div className='text-h4 font-semibold text-primary'>Account Setup</div>
                </div> */}
                <div className="flex flex-col items-center justify-center py-6">
                    <img loading="lazy" className='w-9' src={'/Assets/GrcNavLogo.svg'} alt='nav-logo' />
                    <h2 className="mt-2 text-primary text-xl font-semibold tracking-wide">
                        Account Setup
                    </h2>
                </div>

                <div className='h-[12%] flex justify-center'>
                    <StepperCompenent className={'w-[80%]'} activeStep={activeStepper} stepsData={stepperdData} />
                </div>
                {activeStepper !== OnboardEntity.ORGANIZATION_CHART_STEPPER && <div className='px-4 flex-col items-center h-[69%] flex justify-center'>
                    <Card className='border-[0px] w-[80%] h-[90%] overflow-auto onboarding-card'>
                        <CardContent className='p-5 h-full'>
                            <div className='h-full'>
                                {activeStepper === OnboardEntity.PROFILE_STEPPER && <ProfileScreen reset={reset} control={control} register={register} errors={errors} setError={setError} clearErrors={clearErrors} curencyCode={curencyCode} heatMap={heatMap} profileData={profileData} setValue={setValue} setProfileData={setProfileData} className='px-4 flex-col items-center h-full flex justify-center' />}
                                {activeStepper === OnboardEntity.MANAGEMENT_TEAM_STEPPER && <BoardComposition reset={reset} boardsFormData={boardsFormData} setBoardsFormData={setBoardsFormData} trigger={trigger} errors={errors} control={control} setError={setError} clearErrors={clearErrors} register={register} setValue={setValue}/>}
                                {activeStepper === OnboardEntity.BODIES_LIST_STEPPER && <RegulationList reset={reset} setShowSubmitButton={setShowSubmitButton} regulationTableData={regulationTableData}
                                    setRegulationTableData={setRegulationTableData}
                                    regulationListData={regulationListData}
                                    setRegulationListData={setRegulationListData} />}
                                {activeStepper === OnboardEntity.CONFIGURATION_STEPPER && <ConfigurationsContainer isInitial={true} ref={ref}/>}
                            </div>
                        </CardContent>
                    </Card>
                </div>}
                {activeStepper === OnboardEntity.ORGANIZATION_CHART_STEPPER && <div className='h-full w-full' style={{ boxShadow: 'inset 0px 2px 10px 0px hsl(var(--grey))' }}>
                    <ReactFlowProvider>
                        <OrganizationChart edges={edges} setEdges={setEdges} onEdgesChange={onEdgesChange} nodes={nodes} setNodes={setNodes} onNodesChange={onNodesChange} activeStepper={activeStepper}/>
                    </ReactFlowProvider>
                </div>}
                <div className={cn('onboarding-footer right-[109px] bottom-0 mt-auto h-[10%] flex justify-center', activeStepper === OnboardEntity.ORGANIZATION_CHART_STEPPER ? 'absolute w-[318px]' : 'static ')}>
                    <div className='flex w-[80%]'>
                        {activeStepper !== OnboardEntity.PROFILE_STEPPER && (<Button className='ml-auto w-[120px]' style={{ background: 'hsl(var(--background))' }} onClick={handleBack} variant="outline"><div className='flex'><IoArrowBack style={{ flexShrink: 0, paddingRight: '5px', width: '25px', height: '18px', paddingLeft: '0px' }}/><span className="mr-2">Back</span></div></Button>)}
                        <Button disabled={activeStepper === OnboardEntity.BODIES_LIST_STEPPER && !showSubmitButton && (isLoading || isSubmitting)} className={`mr-5 ${activeStepper === OnboardEntity.PROFILE_STEPPER ? 'ml-auto' : 'ml-4'} ${showSubmitButton && activeStepper === 4 ? 'w-[120px]' : ''}`} onClick={handleSubmit(handleNext)} ><div className='flex items-center'>{showSubmitButton && activeStepper === OnboardEntity.CONFIGURATION_STEPPER ? (<>Submit<IoMdCheckmark style={{ marginLeft: '5px', width: '25px', height: '18px', display: 'inline-block' }}/></>) : (<>Next<span className="flex-shrink-0"><IoArrowForward style={{ marginLeft: '5px', width: '25px', height: '18px', display: 'inline-block' }}/></span></>)}</div></Button>
                    </div>
                </div>
                <Dialog
                    open={isOpenOnboardProfileModal}
                    sx={{ minHeight: '300px' }}
                    PaperProps={{
                        style: { minHeight: '180px', minWidth: '350px' }
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--card))' }}>Success</div>
                        <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <CrossCircledIcon onClick={() => handleCloseModal()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                        </Tooltip>
                    </DialogTitle>
                    <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '0px 24px 0px 24px', borderBottom: '2px solid hsl(var(--border))' }}>
                        Your Organization Profile Created Successfully !
                    </DialogContent>
                    <DialogActions sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Button onClick={handleContinue} autoFocus>
                            Continue
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}

export default OnboardingContainer
